import {Component, Injectable, OnInit, Compiler} from '@angular/core';
import {AuthService} from './services/auth.service';
import {Router} from '@angular/router';
import {TaskDescService} from './services/task-desc.service';
import {FabMessageService} from './services/fab-message.service';
import { TranslateService } from '@ngx-translate/core';
import { ApiConnectService } from './services/api-connect.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

@Injectable()
export class AppComponent implements OnInit {

  modalTaskInfo;

  constructor(private autnService: AuthService,
              private router: Router,
              private taskDescService: TaskDescService,
              private _compiler: Compiler,
              private translate: TranslateService,
              public fabService: FabMessageService,
              public apiConnectService: ApiConnectService
            ) {
                
  }

  ngOnInit() {
    if (!this.autnService.isAuthenticated()) {
      this.router.navigate(['/signin']);
    }
    this.modalTaskInfo = this.taskDescService.getModalTaskInfo();
    this.check(); 
  }

  check() {
    if (localStorage.getItem('lang') === null) {
      this.translate.setDefaultLang('en');
      localStorage.setItem('lang', 'en');
    } else if (localStorage.getItem('lang') === 'ru') {
      this.translate.setDefaultLang('ru');
    } else if (localStorage.getItem('lang') === 'en') {
      this.translate.setDefaultLang('en');
    } else if (localStorage.getItem('lang') === 'ch') {
    this.translate.setDefaultLang('ch');
    } else if (localStorage.getItem('lang') === 'bs') {
      this.translate.setDefaultLang('bs');
  }
  }
}




// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/app.component.ts